export class FunctionUtil {
  static esValidoNumero(value) {
    const esNumero = /^-?\d+([.,]?\d+)?$/.test(value);
    return esNumero && parseFloat(value.replace(',', '.'));
  }
  
  static ejecutarFunction(fn) {
    // eslint-disable-next-line no-new-func
    return new Function('return ' + fn)();
  }
}
